import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { AsyncPipe } from '@angular/common';

import { OrganisationService, OrgAppAccess } from 'src/app/organisation.service';

@Component({
    selector: 'app-app-selection',
    templateUrl: './app-selection.component.html',
    styleUrls: ['./app-selection.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe]
})
export class AppSelectionComponent implements OnInit {
    access: OrgAppAccess;

    constructor(
        public auth: AuthService,
        private orgService: OrganisationService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.orgService.setActiveApp(null);

        this.orgService.currentOrg$.subscribe(org => {
            this.access = this.orgService.getOrgAppAccess(org);
        });
    }

    launchMotorTwin() {
        if (!this.access?.motortwin) {
            return;
        }

        this.orgService.setActiveApp('motortwin');
        this.router.navigate(['/motortwin']);
    }

    launchFmeda() {
        if (!this.access?.fmeda) {
            return;
        }

        this.orgService.setActiveApp('fmeda');
        this.router.navigate(['/fmeda']);
    }
}
